import { padStart } from 'lodash'
import moment from 'moment'
import { useEffect, useState } from 'react'

interface CountdownDiffType {
  days: string
  hours: string
  minutes: string
  seconds: string
}

export const useCountdown = (until: moment.Moment) => {
  const [diff, setDiff] = useState<CountdownDiffType>({
    days: '0',
    hours: '0',
    minutes: '0',
    seconds: '0'
  })

  const calculateDiff = () => {
    const now = moment()
    const duration = moment.duration(until.diff(now))
    setDiff({
      days: padStart(Math.floor(duration.as('days')).toString(), 2, '0'),
      hours: padStart(duration.hours().toString(), 2, '0'),
      minutes: padStart(duration.minutes().toString(), 2, '0'),
      seconds: padStart(duration.seconds().toString(), 2, '0')
    })
  }

  useEffect(() => {
    calculateDiff()
    const interval = setInterval(calculateDiff, 1000)

    return () => clearInterval(interval)
  }, [until])

  return { diff }
}
